export { default } from "./useMultipleChoiceEditor";
